import {type Type, Plugins} from '@packages/systems/wfdl';
import {typeName, qualify} from '@packages/systems/wfdl-Qualified';

const RowEmpty = {type: 'RowEmpty'} as const;

export const migrateRecordDataType = (dataTypeJson: any) => {
  if (dataTypeJson && dataTypeJson.type === 'Record') {
    const newDataType: Type = {
      type: 'TypeApplication',
      val: {
        con: {
          type: 'TypeConstructor',
          val: qualify(Plugins.name('Builtin'), typeName('Record')),
        },
        // @ts-expect-error - TS2322 - Type 'string | { readonly type: "RowEmpty"; }' is not assignable to type 'Type'.
        arg: dataTypeJson.fields
          ? // @ts-expect-error - TS2769 - No overload matches this call.
            Object.keys(dataTypeJson.fields).reduce((row, label) => {
              return {
                type: 'RowCons',
                val: {
                  label,
                  type: dataTypeJson.fields[label],
                  tail: row,
                },
              };
            }, RowEmpty)
          : RowEmpty,
      },
    };

    if (dataTypeJson.system) newDataType.system = dataTypeJson.system;
    if (dataTypeJson.meta) newDataType.meta = dataTypeJson.meta;

    return newDataType;
  }

  return dataTypeJson;
};
